import { FeedbackForm } from 'base/ui/feedback_form';
import { PanelLayout } from 'base/ui/panel';
import { ToastQueue } from 'base/ui/toast';
import { BlocksService } from 'blocks/blocks_service';
import { ProjectSession } from 'blocks/editor/session/session';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getGlobalConceptsStore } from './concept_store';
import { SidebarNavigation } from './routes';

type Props = {
  navigation: SidebarNavigation;
  toastQueue: ToastQueue;
  blocksService: BlocksService;
  session: ProjectSession;
};
export const FeedbackPanel = observer(
  ({ navigation, toastQueue, blocksService, session }: Props) => {
    const conceptsStore = getGlobalConceptsStore();

    const handleSend = async ({ message }: { message: string }) => {
      await blocksService.projectSubmitAppFeedback({
        message,
        type: 'general',
        page: 'styleguide',
        projectToken: session.projectToken,
        concept: conceptsStore.activeConceptIndex + 1,
      });

      toastQueue.push({ label: 'Submitted! Thanks a bunch' });
      navigation.close();
    };

    return (
      <PanelLayout title="Feedback" navigation={navigation}>
        <FeedbackForm onSubmit={handleSend} parentVariant="panel" />
      </PanelLayout>
    );
  },
);
